import { StatsigProvider } from '@statsig/react-bindings';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { useAuthStore } from '@/stores/authStore';

const STATSIG_CLIENT_KEY = import.meta.env.VITE_STATSIG_KEY || 'client-66xcWDva4KGLrstdElpuYUlWp6vzgqdJpiDSCvrYW4M';
const STATSIG_ENABLED = import.meta.env.PROD; // Only enable in production

interface StatsigWrapperProps {
  children: React.ReactNode;
}

function StatsigInner({ children }: StatsigWrapperProps) {
  const user = useAuthStore((state) => state.user);

  return (
    <StatsigProvider
      sdkKey={STATSIG_CLIENT_KEY}
      user={{ userID: user?.id ?? 'anonymous', email: user?.email ?? undefined }}
      loadingComponent={null}
      options={{
        plugins: [
          new StatsigSessionReplayPlugin(),
          new StatsigAutoCapturePlugin(),
        ],
      }}
    >
      {children}
    </StatsigProvider>
  );
}

export function StatsigWrapper({ children }: StatsigWrapperProps) {
  // Skip Statsig in development
  if (!STATSIG_ENABLED) {
    return <>{children}</>;
  }

  return <StatsigInner>{children}</StatsigInner>;
}
